import { render, staticRenderFns } from "./BusinessLicenseSuccess.vue?vue&type=template&id=115735ea&scoped=true"
import script from "./BusinessLicenseSuccess.vue?vue&type=script&lang=js"
export * from "./BusinessLicenseSuccess.vue?vue&type=script&lang=js"
import style0 from "./BusinessLicenseSuccess.vue?vue&type=style&index=0&id=115735ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115735ea",
  null
  
)

export default component.exports